import Header from './components/Header';
import Hero from './components/Hero';
import SectionCarousel from './components/SectionCarousel';
import SectionFeatures from './components/SectionFeatures';
import SectionIndex from './components/SectionIndex';
import SectionContact from './components/SectionContact';
import SectionApp from './components/SectionApp';
import SectionCards from './components/SectionCards';
import SectionMedia from './components/SectionMedia';
import SectionFaq from './components/SectionFaq';
import SectionAbout from './components/SectionAbout';
import SectionRanking from './components/SectionRanking';
import SectionTopics from './components/SectionTopics';
import SectionComments from './components/SectionComments';
import SectionUpdates from './components/SectionUpdates';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionCarousel />
        <SectionFeatures />
        <SectionIndex />
        <SectionContact />
        <SectionApp />
        <SectionCards />
        <SectionMedia />
        <SectionFaq />
        <SectionAbout />
        <SectionRanking />
        <SectionTopics />
        <SectionComments />
        <SectionUpdates />
      </main>
      <Footer />
    </div>
  );
}